import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { ITagTemplate } from "@formant/core/model/ITagTemplate";

import { appStore, groupStore, tagTemplateStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    tagTemplate: ITagTemplate;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        return (
            <Buttons>
                <ActionButton
                    icon="delete"
                    onClicked={this.onDelete}
                    data-tooltip="Remove tag"
                />
            </Buttons>
        );
    }

    private onDelete = async () => {
        const { tagTemplate } = this.props;
        const { tagKey, id } = tagTemplate;
        const groups = await groupStore.fetchList();
        const usedByGroup = groups.find(_ => _.enabled && _.tagKey === tagKey);
        if (usedByGroup) {
            appStore.setSnackbar(
                `Cannot delete tag; in use by group "${usedByGroup.name}"`,
            );
            return;
        }
        appStore.setConfirm({
            title: "Delete tag",
            message: `Delete tag "${tagKey}"?`,
            onOk: async () => {
                await tagTemplateStore.disable(defined(id));
                appStore.setSnackbar("Tag deleted");
            },
        });
    };
}
